import { SelectValueOption } from "./SelectValueOption";

export class FilterOptions {
  arrangements: SelectValueOption[] = [];
  attributes: SelectValueOption[] = [];
  countries: SelectValueOption[] = [];
  states: SelectValueOption[] = [];
  cities: SelectValueOption[] = [];
  sites: SelectValueOption[] = [];
  buildings: SelectValueOption[] = [];
  floors: SelectValueOption[] = [];

  ctry_id = "";
  state_id = "";
  city_id = "";
  site_id = "";
  bl_id = "";
  fl_id = "";
  rm_arrange_type_id = "";

  constructor(initializer?: any) {
    if (!initializer) return;

    if (initializer.arrangements) this.arrangements = initializer.arrangements;
    if (initializer.attributes) this.attributes = initializer.attributes;

    if (initializer.countries) this.countries = initializer.countries;
    if (initializer.states) this.states = initializer.states;
    if (initializer.cities) this.cities = initializer.cities;
    if (initializer.sites) this.sites = initializer.sites;
    if (initializer.buildings) this.buildings = initializer.buildings;
    if (initializer.floors) this.floors = initializer.floors;

    if (initializer.ctry_id) this.ctry_id = initializer.ctry_id;
    if (initializer.state_id) this.state_id = initializer.state_id;
    if (initializer.city_id) this.city_id = initializer.city_id;
    if (initializer.site_id) this.site_id = initializer.site_id;
    if (initializer.bl_id) this.bl_id = initializer.bl_id;
    if (initializer.fl_id) this.fl_id = initializer.fl_id;
    if (initializer.rm_arrange_type_id) this.rm_arrange_type_id = initializer.rm_arrange_type_id;
  }

  /** Determine which sublevels to query for a change on a given level. */
  getFilterSubLevels(level: string): string[] {
    const subLevels: string[] = [];
    switch (level) {
      case "country":
        if (this.states.length > 0) subLevels.push("state");
        if (this.cities.length > 0) subLevels.push("city");
        if (this.sites.length > 0) subLevels.push("site");
        if (this.buildings.length > 0) subLevels.push("building");
        if (this.floors.length > 0) subLevels.push("floor");
        break;
      case "state":
        if (this.cities.length > 0) subLevels.push("city");
        if (this.sites.length > 0) subLevels.push("site");
        if (this.buildings.length > 0) subLevels.push("building");
        if (this.floors.length > 0) subLevels.push("floor");
        break;
      case "city":
        if (this.sites.length > 0) subLevels.push("site");
        if (this.buildings.length > 0) subLevels.push("building");
        if (this.floors.length > 0) subLevels.push("floor");
        break;
      case "site":
        if (this.buildings.length > 0) subLevels.push("building");
        if (this.floors.length > 0) subLevels.push("floor");
        break;
      case "building":
        if (this.floors.length > 0) subLevels.push("floor");
        break;
      default:
        // floor and arrangement type never have sublevels
        break;
    }
    if (subLevels.length == 0) {
      subLevels.push("none");
    }
    return subLevels;
  }
}
